module.exports = __webpack_public_path__ + "static/media/radio-button-group.c851a734.svg";